import { BREAKPOINTS, COLORS } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';


const Topic = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
`;
const TopicContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

const Title = styled.div`
  color: #1D1D1F;

  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; 
`;

const TopicSelection = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px; 
    width: 100%;

    ${BREAKPOINTS.MEDIUM}{
        grid-template-columns: 1fr 1fr;
    }

    ${BREAKPOINTS.LARGE}{
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

const LandingCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 222px;
  border: 1px solid ${COLORS.neutral_200};
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    border: 1px solid ${COLORS.neutral_400};
    
    //transform: translateY(-2px);
  }
`;

const CardImageSection = styled.div`
  width: 100%;
  flex-shrink: 1;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardTextSection = styled.div`
  padding: 16px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${COLORS.black};
  background: ${COLORS.neutral_20};
  
`;

interface TopicsProps {
  title?: string;
  items: TopicItem[]
  onItemClick?: (item: TopicItem, index: number) => void;
}
export interface TopicItem {
  asset: string;
  text: string;
  link: string;
}

const Topics = ({title, items, onItemClick}: TopicsProps) => {
  const { t } = useTranslation("translation");
    
  const navigate = useNavigate()
  
    return (
        <Topic>
            <TopicContainer>
              { !!title &&
                <Title>{t(title)}</Title>
              }
              <TopicSelection>
                { items.map((item, index) =>
                    <LandingCard 
                      key={`link-${index}`}
                      onClick={() => { 
                          posthog?.capture('SUPP-Topics-CardClick', {
                            component: 'Topics',
                            text: item.text,
                            link: item.link
                          });
                          onItemClick?.(item, index);
                          if(item.link.startsWith("http"))
                            window.location.href = item.link;
                          else
                            navigate(item.link);
                        }}
                    >
                      <CardImageSection>
                        <img src={item.asset ?? '/assets/ProductPageDefault.png'} alt={item.text} />
                      </CardImageSection>
                      <CardTextSection>
                        {t(item.text)}
                      </CardTextSection>
                    </LandingCard>
                  )
                }
              </TopicSelection>
            </TopicContainer>
          </Topic>
    );
}

export default Topics;